import styled from 'styled-components';
import { ReferecePoint } from '../inputs/ReferencePoint';
import { PositionInputGroup } from './PositionInputGroup';

export const ReferencePositionInputGroup = () => {
  return (
    <Container>
      <Column>
        <PositionInputGroup />
      </Column>
      <Column style={{ paddingLeft: '30px' }}>
        <ReferecePoint />
      </Column>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 15px;
`;

const Column = styled.div`
  box-sizing: border-box;
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
`;
